import api from "./api";

// 教练列表展示
export const postCoachList = params => {
  return api("post", `/v1/management/coach/list`, params);
};

// 编辑教练
export const postEditCoach = params => {
  return api("post", `/v1/management/coach/editCoach`, params);
};

// 教练详情
export const getCoachDetails = params => {
  return api("get", `/v1/management/coach/coachDetails/${params}`);
};

// 导出教练模板
export const getCoachTemplate = params => {
  return api("get", `/v1/management/coach/exportCoachTemplate`, params, {
    responseType: "blob",
  });
};

// 导入EXCEL教练信息
export const postUploadCoach = params => {
  const formData = new FormData();
  formData.append("file", params.file);
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("post", `/v1/management/coach/uploadCoachExcel`, formData, config);
};

// 下拉框数据
export const getCoachSelect = params => {
  return api("get", `/v1/management/coach/coachSelect`, params);
};

// 导出教练名单
export const exportCoachList = params => {
  return api("get", `/v1/management/coach/coachList`, params, {
    responseType: "blob",
  });
};

// 教练卡券管理列表
export const getCardVoucher = params => {
  return api("post", `/v1/management/coach/coach-card-voucher`, params);
};

// 教练卡券导入
export const postImportCode = params => {
  return api("post", `/v1/management/coach/coach-virtual-exchange-code`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 教练时长列表
export const postTaskDuration = params => {
  return api("post", `/v1/management/coach/coach-task-duration`, params);
};

// 导出教练时长
export const postExportTask = params => {
  return api("post", `/v1/management/coach/coach-task-duration/excel`, params, {
    responseType: "blob",
  });
};

// 教练时长详情
export const postTaskSave = params => {
  return api("post", `/v1/management/coach/coach-task-duration/save`, params);
};

// 教练时长详情
export const getTaskDetails = params => {
  return api(
    "get",
    `/v1/management/coach/coach-task-duration/${params.coachId}/${params.dateMonth}`
  );
};
